import React from 'react';
import PropTypes from 'prop-types';

const ProviderCardNotAccepting = ({
  display,
  phoneNumber,
  onlineSchedulingEnabled,
  reasonForVisitName,
}) => (
  <div className="padding-sm text-align-center">
    {!onlineSchedulingEnabled ? (
      <h4 className="font-family-meta-bold margin-none">
        {display} is not accepting appointments online at the moment.
      </h4>
    ) : (
      <h4 className="font-family-meta-bold margin-none">
        {display} does not have any openings online for {reasonForVisitName} at the moment.
      </h4>
    )}
    <p className="font-size-xs line-height-copy">
      Please call us at <span className="text-nowrap font-family-meta-bold">{phoneNumber}</span> to
      schedule your appointment.
    </p>
  </div>
);

ProviderCardNotAccepting.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  onlineSchedulingEnabled: PropTypes.bool,
  reasonForVisitName: PropTypes.string.isRequired,
};

export default ProviderCardNotAccepting;
